// FLAGS: consent
// Loads the Cookiebot banner once, from the boot, in the language the app resolved (prefix, flag, saved profile or
// hostname); a language change without a reload keeps the boot's language. Off under Cypress and `disable-cookiebot`.
// Never throws: a failure is reported and the page carries on without the banner.
import { reportBootFailure } from "@src/boot/bootLoader";

const COOKIEBOT_CBID = "a4e8d3fc-f691-499c-bdd4-b6dd733dd373";
// The banner languages configured in Cookiebot; any other language asks in English.
const COOKIEBOT_CULTURES = new Set(["NL", "EN", "DE", "FR", "ES"]);

const cultureFor = (language: string | undefined): string => {
  const culture = (language ?? "").slice(0, 2).toUpperCase();
  return COOKIEBOT_CULTURES.has(culture) ? culture : "EN";
};

// Blocked storage reads as not disabled, so it cannot cost a visitor the banner.
const isDisabled = (): boolean => {
  if ((window as { Cypress?: unknown }).Cypress) {
    return true;
  }
  try {
    return window.localStorage.getItem("disable-cookiebot") === "true";
  } catch {
    return false;
  }
};

const injectCookiebot = (language: string | undefined): void => {
  try {
    if (isDisabled() || document.getElementById("Cookiebot")) {
      return;
    }
    const script = document.createElement("script");
    script.id = "Cookiebot";
    script.src = "https://consent.cookiebot.com/uc.js";
    script.type = "text/javascript";
    script.dataset.cbid = COOKIEBOT_CBID;
    script.dataset.culture = cultureFor(language);
    document.head.appendChild(script);
  } catch (error) {
    reportBootFailure(error);
  }
};

export default injectCookiebot;
